export default [
  {
    id: 'financial-manager-data-same-as-contractor',
    name: 'sameAsContractor',
    label:
      'smb_acquisition_checkout.form.financial_manager_data.same_as_contractor',
    componentType: 'checkbox',
    columnSize: {
      small: 12,
      medium: 12,
    },
    validations: {
      primitiveType: 'boolean',
      required: false,
    },
  },
  {
    id: 'financial-manager-data-name',
    name: 'financialOfficerName',
    label: 'smb_acquisition_checkout.form.financial_manager_data.name',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'financial-manager-data-email',
    name: 'financialOfficerEmail',
    label: 'smb_acquisition_checkout.form.financial_manager_data.email',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      email: true,
      required: true,
    },
  },
]
